import React from 'react';
import { useNavigate } from 'react-router-dom';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateRack from '../../sections/dashboard/racks/CreateRack';
import CreateRackModal from '../../sections/dashboard/racks/CreateRackModal';

// import DeliveriesNotification from '../../sections/dashboard/racks/DeliveriesNotification';

const Racks = () => {
  const navigate = useNavigate();

  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          {/* <DeliveriesNotification /> */}
          <CreateRack />
          <TableComponent
            tableBaseUrl="warehouse-service/api/v1/racks"
            tblSearhURI="warehouse-service/api/v1/racks/search"
            cellNavigation={(data) => {
              navigate(`/rack/${data.rackId}/bins`);
            }}
            filterData={{
              'Bin Count': 'binCount',
              'Rack Status': 'rackStatus',
              // 'Updated Date': 'lastUpdatedDate',
            }}
            tableHeader={[
              'rackName',
              'rackLocation',
              'binCount',
              'rackStatus',
              // 'lastUpdatedDate',
            ]}
            mappingData={{
              rackName: 'Rack Name',
              rackLocation: 'Rack Location',
              binCount: 'Bin Count',
              rackStatus: 'Rack Status',
              // lastUpdatedDate: 'Updated Date',
            }}
          />
        </Container>
        <Modal>
          <CreateRackModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default Racks;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
